module.exports = __webpack_public_path__ + "img/oufu_100x135x14.prt.a160abb7.jpg";